import {
  CheckmarkCircleFillIcon,
  ErrorFillIcon,
} from '@design-systems/react-icons'

/**
 * Mapping of vettingStatusName : allConfigs
 * 0. Started             : CheckIcon, blue
 * 1. Initiated           : CheckIcon, blue
 * 2. Submitted           : CheckIcon, green
 * 3. Approved            : CheckIcon, green
 * 7. Approved Start VFA  : CheckIcon, green
 * 8. Approved Bypass VFA : CheckIcon, green
 * 6. Approved But Hold   : CheckIcon, green
 * 20. System Approved    : CheckIcon, green
 * 9. Review Completed    : CheckIcon, green
 * 5. Sent Back           : Exclamation, yellow
 * 4. Rejected            : Exclamation, red
 */
const VettingStepConfig = {
  started: {
    icon: CheckmarkCircleFillIcon,
    class: 'hc8-clr-brand',
  },
  initiated: {
    icon: CheckmarkCircleFillIcon,
    class: 'hc8-clr-brand',
  },
  submitted: {
    icon: CheckmarkCircleFillIcon,
    class: 'hc8-clr-success',
  },
  approved: {
    icon: CheckmarkCircleFillIcon,
    class: 'hc8-clr-success',
  },
  'approved start vfa': {
    icon: CheckmarkCircleFillIcon,
    class: 'hc8-clr-success',
  },
  'approved bypass vfa': {
    icon: CheckmarkCircleFillIcon,
    class: 'hc8-clr-success',
  },
  'approved but hold': {
    icon: CheckmarkCircleFillIcon,
    class: 'hc8-clr-success',
  },
  'rfi3 approved': {
    icon: CheckmarkCircleFillIcon,
    class: 'hc8-clr-success',
  },
  'review complete': {
    icon: CheckmarkCircleFillIcon,
    class: 'hc8-clr-success',
  },
  'sent back': {
    icon: ErrorFillIcon,
    class: 'color-yellow',
  },
  rejected: {
    icon: ErrorFillIcon,
    class: 'hc8-clr-warning',
  },
  'system approved': {
    icon: CheckmarkCircleFillIcon,
    class: 'hc8-clr-success',
  },
}

export default VettingStepConfig
